import React from 'react';
import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions';
import { LegacyContentExtensionHandler as BaseLegacyContentExtensionHandler } from '@confluence/fabric-extension-handlers/entry-points/LegacyContentExtension.ts';
import type { LegacyContentMacroParams } from './legacy-content-macro-params.ts';

const LegacyContentExtensionHandler = (
	props: ExtensionComponentProps<LegacyContentMacroParams>,
) => <BaseLegacyContentExtensionHandler {...props} />;

// eslint-disable-next-line import/no-default-export
export default LegacyContentExtensionHandler;
